import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { HttpService } from '../../services/http.service';
import { UtilsService } from '../../services/utils.service'
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { USER_MGMT_CNST } from '../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
import { Config, Path } from '../../enums';
import { InitService } from '../../parsers/init.service';
import { AuthenticationService } from '../../modules/authentication/services/authentication.service';
import { AppStateService } from '../../services/app-state.service';
import { EnvService } from '../../services/env.service';
import { isNullOrUndefined } from '../../modules/shared/common-utils';
import { DeleteComponent } from '../../modules/shared/components/delete/delete.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {
  tableConfig: any = {}
  tableData: any = [];

  showSearchCustomers = true;
  loading: boolean = true;
  updateInProcess: boolean = false;
  addConfig: any;
  isEditPermission: boolean = false;

  loadMoreRecordsOnScroll: boolean = true;
  fetchedRecordsCount: number = 0;
  currentPage: number = 0;
  currentOffset: number = 0;

  //*Infinite scrolling related variables
  scrollDistance!: number;
  throttle!: number;
  isScrollOnWindow!: boolean;

  subscriptions: Subscription[] = [];
  wasPageScrolled!: boolean;
  loggedInUserFlag: boolean = false;
  currentResponseLength!: number;
  customerListData: any;
  isCustomer: any;
  customerSelected: any;
  userListData: any[] = [];
  userSelected: any[] = [];

  constructor(
    private commonSrv: CommonService,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private utilSrv: UtilsService,
    private appStateSrv: AppStateService,
    private authStateSrv: AuthenticationService,
    private initSrv: InitService,
    private envService: EnvService,
    private datePipe: DatePipe,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    let permissions = this.appStateSrv.getUserPermissions();

    if(permissions && permissions['User Management'] && permissions['User Management']['resources'] && permissions['User Management']['resources']['ROLE'] && permissions['User Management']['resources']['ROLE']['actions']) {
      this.isEditPermission = permissions['User Management']['resources']['ROLE']['actions'].indexOf('EDIT') !== -1 ? true : false;
    }

    // if(permissions && permissions['User Management'] && permissions['User Management']['userRoleScope'] && permissions['User Management']['userRoleScope']['scope']) {
    //   this.isCustomer = permissions['User Management']['userRoleScope']['scope'].length > 0 ? true: false; 
    // }else {
      let metaInfo = this.appStateSrv.getUserMetaInfo();
      this.isCustomer = metaInfo && (isNullOrUndefined(metaInfo['customerId']) || isNullOrUndefined(metaInfo['customerName'])) ? true : false;
    // }
    // if(permissions && permissions['User Management']&&permissions['User Management']['roleName'] == "Customer Administrator")
    // {
    //   this.showSearchCustomers = false;
    // }
    console.log("permissions",permissions)

    this.setTableConfig();
    this.setTableData();

    const operationRef = this.appStateSrv.operationRef.subscribe(
      (value: any) => {
        let { operation, postData } = value;

        if (operation === USER_MGMT_CNST.OPERATION_TYPES.USER.DELETE_USER) {
          this.deleteUser(postData)
        } else if (operation === USER_MGMT_CNST.OPERATION_TYPES.USER.EDIT_USER) {
          this.updateUser(postData);
        }
      }
    );

    this.wasPageScrolled = this.appStateSrv.getWasPageScrolled();

    const pageScrolledRef = this.appStateSrv.wasPageScrolledRef.subscribe((value: boolean) => {
      this.wasPageScrolled = value;
      if (this.loadMoreRecordsOnScroll) {
        if (this.customerSelected) {
          this.customerBasedUserList(this.customerSelected['customerId']);
        } else {
          this.setTableData();
        }
      }
    });

    this.subscriptions.push(operationRef);
    this.subscriptions.push(pageScrolledRef);
    this.initializeInfiniteScrollVariables();
    if (this.isCustomer) {
      console.log("inside if loop")
      this.setCustomerListData();
    }
  }

  onClick(event: any) {
    event.stopPropagation();
    this.clearCustomerOptions()
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  initializeInfiniteScrollVariables() {
    let { SCROLL_DISTANCE, THROTTLE, SCROLL_ON_WINDOW } = USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS;

    this.scrollDistance = SCROLL_DISTANCE;
    this.throttle = THROTTLE;
    this.isScrollOnWindow = SCROLL_ON_WINDOW;
  }

  addUserModal() {
    let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
    if (!this.isCustomer) {
      this.router.navigate(['um', 'users', 'config'], {
        queryParams: {
          operation: USER_MODULE_OPERATIONS.ADD_USER
        }
      })
    } else {
      this.router.navigate(['um', 'users', 'config'], {
        queryParams: {
          operation: USER_MODULE_OPERATIONS.ADD_USER,
          title:'add'
        }
      })
    }
  }

  initializeAddUserConfig() {
    return this.initSrv.loadConfig({
      path: Path.ADD_USER_CONFIG_PATH,
      configType: Config.ADD_USER_CONFIG
    });
  }

  setTableConfig() {
    this.tableConfig = this.commonSrv.setTableConfig(!this.isCustomer ? USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST : USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST);
    // this.tableConfig.hasInfiniteScroll = true;
  }

  setTableData() {

    let options = {
      'queryParams': {
        size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
        offset: this.currentOffset
      }
    }

    this.loading = true;
    this.httpSrv.makeGetApiCall('GET_USER_LIST', this.envService.baseUrl, options).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          this.commonTableDataFormater(userList);
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.utilSrv.showToastMessage("Failed to fetch users list", "error");
        }
      });
  }

  deleteUser(postdata: any) {
    this.httpSrv.makeDeleteApiCall('KEYCLOAK_DELETE_USER', this.envService.baseUrl, { uriParams: { userId: postdata.userId } }).subscribe({
      next: (res: any) => {
        this.resetVariables();
        this.setTableData();
        this.userListData = [];
        this.userSelected = [];
        this.utilSrv.showToastMessage('User deleted Successfully', 'success');
      },
      error: () => {
        this.utilSrv.showToastMessage('Error occured while deleting the user', 'error');
      }
    });
  }

  updateUser(postdata: any) {

    if (this.updateInProcess) return;

    this.updateInProcess = true;
    if (postdata['metaInfo']) {
      postdata['metaInfo']['status'] = postdata['metaInfo']['status'] === USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE ? true : false;
    }
    const { userId = '', operation, ...rest } = postdata;
    this.httpSrv.makePutApiCall('UPDATE_USER', rest, this.envService.baseUrl, { uriParams: { userId } }).subscribe({
      next: (res: any) => {
        this.updateInProcess = false;
        this.resetVariables();
        this.setTableData();
        this.utilSrv.showToastMessage('Successfully updated user details', 'success');
      },
      error: () => {
        this.utilSrv.showToastMessage("Error occured while updating the user", 'error');
      }
    });
  }

  formatCustomerList(response: any) {
    let formattedCustomerList = [];

    for (let custId in response) {
      let customerInfo = response[custId];
      formattedCustomerList.push(customerInfo);
    }

    return formattedCustomerList;
  }

  handleTableScroll() {
    if (this.loadMoreRecordsOnScroll) {
      this.setTableData();
    }
  }

  setCustomerListData() {
   if(Object.keys(this.appStateSrv.getUserPermissions()?.['User Management']?.['resources']).includes("CUSTOMER")) {
    this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        let customerListData = this.formatTableData(response);
        this.customerListData = this.dataSrv.addOptionsToTableData(customerListData, UM_TABLE_CNST.RESOURCES_LIST.customers);
      },
      error: () => {
        this.utilSrv.showToastMessage("Failed to fetch customers list", "error");
      }
    });
   }
  }

  formatTableData(data: any) {
    let customerKeys = Object.keys(data);
    let customerList = customerKeys.map(cust => {
      let customer = data[cust];
      customer['addedDate'] = this.datePipe.transform(new Date(customer['addedDate']), "dd MMM yyyy");
      return customer;
    })
    return customerList;
  }

  onCustomerSelect(e: any) {
    if (!isNullOrUndefined(e)) {
      this.resetVariables();
      this.userSelected = [];
      this.userListData = [];
      this.customerBasedUserList(e.customerId)
    }
  }

  clearCustomerOptions() {
    this.resetVariables();
    this.setTableData();
  }

  resetVariables() {
    this.loadMoreRecordsOnScroll = true;
    this.currentPage = 0;
    this.currentOffset = 0;
    this.loggedInUserFlag = false;
    this.tableData = [];
  }
  customerBasedUserList(customerId: any) {
    let options = {
      'uriParams': {
        customerId: customerId
      },
      'queryParams': {
        size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
        offset: this.currentOffset
      }
    }
    this.loading = true;
    this.httpSrv.makeGetApiCall('GET_USER_LIST', this.envService.baseUrl, options).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          this.commonTableDataFormater(userList);
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.utilSrv.showToastMessage("Failed to fetch users list", "error");
        }
      })
  }

  commonTableDataFormater(userList: any) {

    if (userList.length === 0) {
      this.loadMoreRecordsOnScroll = false;
    }

    this.currentResponseLength = userList.length;

    let updatedList = userList.map((user: any) => {
      if (user['lastLoginTs']) {
        user['lastLoginTs'] = this.datePipe.transform(new Date(user['lastLoginTs']), "dd MMM yyyy");
      }
      return user;
    });

    let tableData: any = this.dataSrv.addOptionsToTableData(updatedList, UM_TABLE_CNST.RESOURCES_LIST.user);
    const userMap: any = {};


    const loggedInUserId = this.authStateSrv.getUserId();
    if (tableData.find((r: any) => r.userId === loggedInUserId)) {
      this.loggedInUserFlag = true;
    }
    // Filter the current user record
    tableData = tableData.filter((r: any) => r.userId !== loggedInUserId);


    tableData.forEach((record: any, i: any) => {

      let user = userMap[record.userId];
      const { applicationName, applicationId, roleName, roleId, updatedBy, updatedTs, ...rest } = record;

      const application = {
        applicationName,
        applicationId,
        roleName,
        roleId
      }

      let updateInfo = '-';
      try {
        if (updatedBy && updatedTs) {
          const formattedDate = this.datePipe.transform(new Date(updatedTs), "dd MMM yyyy hh:mm a");
          updateInfo = `${updatedBy},\n${formattedDate || '-'}`;
        }
      } catch (e) {
        updateInfo = '-';
      }

      if (!user) {
        user = { ...rest };
        user.applications = [application];
         if (!user.updatedInfo || new Date(record.updatedTs) > new Date(user.updatedTs)) {
          user['updatedInfo'] = updateInfo;
        }
      } else {
        user.applications = [...user['applications'], application];
         // Only update if newer timestamp (optional)
        if (!user.updatedInfo || new Date(record.updatedTs) > new Date(user.updatedTs)) {
          user['updatedInfo'] = updateInfo;
        }
      }
      // user.status = record.status === USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE ? true : false;
      userMap[record.userId] = user;
    })

    this.tableData = [...this.tableData, ...Object.values(userMap)];

    let modifiedTableData = this.tableData.map((e: any) => {

      e['applicationDetails'] = {
        applicationName: e.applications[0]['applicationName'], roleName: e.applications[0]['roleName']
      }
      return e;
    });

    this.tableData = modifiedTableData;


    this.currentPage++;
    if (this.currentResponseLength === USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT) {
      this.currentOffset += USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT;
    }
    else {
      this.loadMoreRecordsOnScroll = false;
    }
    this.loading = false;
  }

  fetchUsers(text: any) {
    let optionsList = {
      'queryParams': {
        userName: text,
        ...((this.customerSelected) && { customerId: this.customerSelected['customerId'] }),
      }
    }

    this.httpSrv.makeGetApiCall('SEARCH_USERS', this.envService.baseUrl, optionsList).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          this.userListData = userList;
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.utilSrv.showToastMessage("Failed to fetch users list", "error");
        }
      })
  }

  makeChoice(e: any) {
    this.userListData = [];
    if (e && e['term'] && e.term.length > 2) {
      this.fetchUsers(e['term']);
    }
  }

  onUserSelect(e: any) {
    if (!isNullOrUndefined(e) && e.length > 0) {
      this.resetVariables();
      this.commonTableDataFormater(e);
    } else {
      this.clearCustomerOptions();
    }
  }

  onSelectAll() {
    this.userSelected = this.userListData;
    this.onUserSelect(this.userSelected);
  }

  clearUserOptions() {
    this.resetVariables();
    this.userListData = [];
    this.userSelected = [];
    if (this.customerSelected) {
      this.customerBasedUserList(this.customerSelected['customerId']);
    }
  }

  handleOptionClick(rowData: any) {
    let data = this.tableData.find((d: any)=> d.emailId === rowData.data[1]['values'][0]);
    let e = {
      val : rowData['val'],
      data : data
    }

    if(rowData['val'] == USER_MGMT_CNST.OPTIONS.DELETE) {
      // const modalRef = this.modal.open(DeleteComponent, USER_MGMT_CNST.DELETE_POPUP_OPTIONS);
      const dialogRef = this.dialog.open(DeleteComponent, {
        disableClose: false,
        data: {},
      });
      let postData = {
        userId: data.userId
      }

      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          this.setOperationType({
            operation: USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.DELETE_CUSTOMER,
            postData
          })
        }
      });
    }else {
      let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
      this.router.navigate(['um','users','config'], {
        queryParams: {
          operation: USER_MODULE_OPERATIONS.UPDATE_USER,
          userId: data.userId,
          config: 'info'
        }
      })
      // this.commonSrv.handleOptionClick(e, !this.isCustomer? USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST : USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST);
    }
  }

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }

  handleRowClick(rowdata: any, index: any) {

  }
  assertUserData(item: any): { username: string } {
    return item as { username: string };
  }
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Backspace') {
      this.clearCustomerOptions()
    }
  }
}
